import React, { useState, useEffect } from "react";

export default function CheckboxGroup({ options, onSubmit, prevValue }) {
  const [selected, setSelected] = useState(prevValue || []);

  useEffect(() => {
    if (prevValue && prevValue.includes("None") && prevValue.length > 1) {
      setSelected(["None"]);
    } else if (prevValue) {
      setSelected(prevValue);
    } else {
      setSelected([]);
    }
  }, [prevValue]);

  function toggle(opt) {
    if (opt === "None") {
      setSelected(selected.includes("None") ? [] : ["None"]);
    } else {
      let arr = selected.filter(x => x !== "None");
      if (arr.includes(opt)) {
        arr = arr.filter(x => x !== opt);
      } else {
        arr = [...arr, opt];
      }
      setSelected(arr);
    }
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        onSubmit(selected);
      }}
    >
      <div className="space-y-3 mb-6">
        {options.map((opt) => (
          <label
            key={opt}
            className={`flex items-center gap-4 p-4 rounded-lg border-2 text-lg font-medium
              ${selected.includes(opt) ? "border-[#A3B18A] bg-[#DDE5B6]" : "border-[#DDE5B6] bg-[#F6F5EC]"}`}>
            <input
              type="checkbox"
              checked={selected.includes(opt)}
              onChange={() => toggle(opt)}
              className="w-7 h-7 rounded-lg accent-[#769656] border-[#A3B18A] mr-2"
              style={{ minWidth: 28, minHeight: 28 }}
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>
      <button
        type="submit"
        className="w-full px-4 py-3 rounded-lg font-semibold bg-[#A3B18A] hover:bg-[#769656] text-white"
        disabled={selected.length === 0}
      >
        Next
      </button>
    </form>
  );
}
